// extracted by mini-css-extract-plugin
module.exports = {"tip":"Tip_tip__1Se2x","tipToTop":"Tip_tipToTop__2nigg"};